import { Box, DarkMode, LightMode } from "@chakra-ui/react"
import { Footer } from "@/-components/Footer"
import { HeroUserFlows } from "@/-sections/Heroes/UserFlows"
import Logos from "@/-sections/Logos"
import { Collaboration } from "@/-sections/Collaboration"
import { Testimonials } from "@/-sections/Testimonials"
import { JoinBanner } from "@/-sections/JoinBanner"
import { UserFlowsEditor } from "@/-sections/UserFlow/Editor"

const UserFlows = () => {
    return (
        <DarkMode>
            <Box w="full" bg="white">
                <Box w="full" bg="blue.600" py={{ base: 10, lg: 20 }} pb={{ base: 24, lg: 40 }}>
                    <HeroUserFlows />
                </Box>
                <LightMode>
                    <Logos />
                    <UserFlowsEditor />
                    <Collaboration />
                    <Testimonials />
                    <JoinBanner bgColor="#034024" />
                </LightMode>
                <Footer bgColor="#034024" />
            </Box>
        </DarkMode>
    )
}

export default UserFlows